import React, { useState, useEffect, useRef } from "react";
import { Button,Card,Col,Row,ProgressBar,Modal,Form } from "react-bootstrap";
import "components/custom.css";
import currentStatus from "components/current-status.jpg";
import completeStatus from "components/current-status-complete.jpg";
import playingStatus from "components/current-status-playing.jpg";
import completeRecord from "components/current-status-record-complete.jpg";
import currentRecording from "components/current-status-recording.jpg";
import img from "components/a.png";
import { s3base } from "api.js";
import IntroTest from "components/Question/Speaking/IntroTest.jsx";
import { store } from "store/index";
import ReusableRecorder from "components/Recorder/ReusableRecorder.jsx";
import MicWaveform from "components/Question/Speaking/MicWaveform";
import stopImage from "assets/images/stop recording.png";
import grayImage from "assets/images/gray circle.png";
import Sound from "react-sound";
import FullScreen from "assets/images/FullScreen.png";
import DarkMode from "assets/images/DarkMode.png";
import HeadsetCheck from "assets/images/HeadphoneNewCheck.png";
import InfoImage from "assets/images/info.png";
import ExitFullScreen from "assets/images/ExitFullScreen.png";
import LightMode from "assets/images/LightMode.png";
import { toggleFullScreen, toggleTheme, isFullScreen, isDarkMode } from "util/helper";

const ResourceCheck = (props) => {
  const recorderRef = useRef(null);
  const [questionData, setQuestionData] = useState([]);
  const [soundStatus, setSoundStatus] = useState(false);
  const [isBlocked, setIsBlocked] = useState(false);
  const [volume, setVolume] = useState(100);
  const [soundPer, setSoundPer] = useState(0);
  const [recordPer, setRecordPer] = useState(0);
  const [isRecording, setIsRecording] = useState(false);
  const [recordingSoundStatus, setRecordingSoundStatus] = useState(false);
  const [btnText, setBtnText] = useState("Playback");
  const [mic, setMic] = useState(false);
  const [headphone, setHeadphone] = useState(false);
  const [keyboard, setKeyboard] = useState(false);
  const [testDetail, setTestDetail] = useState(false);
  const [currDetail, setCurrDetail] = useState(false);
  const [sequenceArr, setSequenceArr] = useState([]);
  const [index, setIndex] = useState(0);
  const [nextFlag, setNextFlag] = useState(false);
  const [startFlag, setStartFlag] = useState(false);
  const [intro, setIntro] = useState(false);
  const [speak_inst, setSpeakInst] = useState(false);
  const [test_intro, setTestIntro] = useState(false);
  const [modal, setModal] = useState(false);
  const [blobURL, setBlobURL] = useState("");
  const [recordingStartTime, setRecordingStartTime] = useState(null);
  const [recordingInterval, setRecordingInterval] = useState(null);
  const [waveformKey, setWaveformKey] = useState(0);
  const [isStop, setIsStop] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [, forceUpdate] = useState();
  
  useEffect(() => {
    navigator.mediaDevices.getUserMedia(
      { audio: true },
      () => {
        console.log("Permission Granted");
        setIsBlocked(false);
      },
      () => {
        console.log("Permission Denied");
        setIsBlocked(true);
      }
    );

    let arr;
    if (props.cat === 1) {
      arr = ["headphone", "mic"];
      setSequenceArr(arr);
    } else if (props.cat === 2) {
      arr = ["keyboard"];
      setSequenceArr(arr);
    } else if (props.cat === 3) {
      arr = ["headphone", "mic", "keyboard"];
      setSequenceArr(arr);
    } else if (props.cat === 4) {
      arr = ["headphone", "mic", "keyboard"];
      setSequenceArr(arr);
    } else if (props.cat === 5 && props.pending == 1) {
      arr = ["headphone", "mic", "keyboard"];
      setSequenceArr(arr);
    } else if (props.cat === 5 && props.pending == 0) {
      arr = [
        "headphone",
        "mic",
        "keyboard",
        "test_intro",
        "speak_inst",
        "testDetail",
        "currDetail",
        "intro",
      ];
      setSequenceArr(arr);
    }

    let flag = false;
    if (arr && arr[0] === "keyboard") {
      flag = true;
    }

    // Set initial state based on first item in sequence
    if (arr && arr.length > 0) {
      switch(arr[0]) {
        case "headphone":
          setHeadphone(true);
          break;
        case "mic":
          setMic(true);
          break;
        case "keyboard":
          setKeyboard(true);
          break;
        case "test_intro":
          setTestIntro(true);
          break;
        case "speak_inst":
          setSpeakInst(true);
          break;
        case "testDetail":
          setTestDetail(true);
          break;
        case "currDetail":
          setCurrDetail(true);
          break;
        case "intro":
          setIntro(true);
          break;
      }
      setNextFlag(flag);
    }
  }, [props.cat, props.pending]);

  const onSound = () => {
    setSoundStatus(true);
  };

  const offSound = () => {
    setSoundStatus(false);
    setNextFlag(true);
  };

  const handleSongFinishedPlaying = () => {
    setSoundStatus(false);
    setNextFlag(true);
  };

  const recordingFinishedPlaying = () => {
    setRecordingSoundStatus(false);
    setBtnText("Playback");
    setIsCompleted(true);
    setNextFlag(true);
  };

  const changeRange = (e) => {
    setVolume(e.target.value);
  };

  const handleSongPlaying = (obj) => {
    setSoundPer((obj.position * 100) / obj.duration);
  };

  const handleRecordPlaying = (obj) => {
    setRecordPer((obj.position * 100) / obj.duration);
  };

  const nextButton = () => {
    setRecordingSoundStatus(false);
    setSoundStatus(false);
    setSoundPer(0);
    if (index < sequenceArr.length - 1) {
      const arr = sequenceArr;
      const oldIndex = index;
      const newIndex = index + 1;
      let flag = false;
      let mod = false;

      if (
        arr[newIndex] === "keyboard" ||
        arr[newIndex] === "testDetail" ||
        arr[newIndex] === "currDetail" ||
        arr[newIndex] === "test_intro" ||
        arr[newIndex] === "speak_inst" ||
        arr[newIndex] === "intro"
      ) {
        flag = true;
      }

      // Reset all states
      setHeadphone(false);
      setMic(false);
      setKeyboard(false);
      setTestDetail(false);
      setCurrDetail(false);
      setTestIntro(false);
      setSpeakInst(false);
      setIntro(false);

      // Set new state
      switch(arr[newIndex]) {
        case "headphone":
          setHeadphone(true);
          break;
        case "mic":
          setMic(true);
          break;
        case "keyboard":
          setKeyboard(true);
          break;
        case "test_intro":
          setTestIntro(true);
          break;
        case "speak_inst":
          setSpeakInst(true);
          break;
        case "testDetail":
          setTestDetail(true);
          break;
        case "currDetail":
          setCurrDetail(true);
          break;
        case "intro":
          setIntro(true);
          break;
      }

      setIndex(newIndex);
      setNextFlag(flag);
      setModal(mod);
    } else {
      if (sequenceArr[index] === "intro") {
        setModal(true);
      } else {
        setStartFlag(true);
      }
    }
  };

  const playRecording = () => {
    if (recordingSoundStatus) {
      setRecordingSoundStatus(false);
      setBtnText("Playback");
      setNextFlag(true);
      setIsCompleted(true);
    } else {
      setRecordingSoundStatus(true);
      setBtnText("Stop Playback");
    }
  };

  const nextStep = () => {
    if (index < sequenceArr.length - 1) {
      setNextFlag(true);
    } else {
      setStartFlag(true);
    }
  };

  const startRecording = () => {
    if (isBlocked) {
      alert("Please attach your microphone");
    } else {
      // Reset progress and force waveform re-render
      setRecordPer(0);
      setBlobURL("");
      setIsCompleted(false);
      setWaveformKey(prev => prev + 1);
      recorderRef.current?.startRecording();
    }
  };

  const toggleYes = () => {
    setModal(false);
    setStartFlag(true);
    props.showTest();
  };

  const toggle = () => {
    setModal(false);
  };

  const stopRecording = () => {
    if (!isBlocked) {
      recorderRef.current?.stopRecording();
    }
    setIsStop(true)
  };

  const handleRecordingComplete = (recordingData) => {
    setBlobURL(recordingData.url);
    setIsRecording(false);
    setRecordPer(100); // Set to 100% when complete
    if (recordingInterval) {
      clearInterval(recordingInterval);
      setRecordingInterval(null);
    }
  };

  const handleRecordingStart = () => {
    setIsRecording(true);
    setBlobURL("");
    setRecordPer(0);
    const startTime = Date.now();
    setRecordingStartTime(startTime);
    
    // Update progress every 100ms during recording
    const interval = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min((elapsed / 40000) * 100, 100); // 40 seconds max
      setRecordPer(progress);
    }, 100);
    
    setRecordingInterval(interval);
  };

  const handleRecordingStop = () => {
    setIsRecording(false);
    if (recordingInterval) {
      clearInterval(recordingInterval);
      setRecordingInterval(null);
    }
  };

  // Check if we should auto-start
  if (
    sequenceArr[index] !== "intro" &&
    index === sequenceArr.length - 1 &&
    !startFlag
  ) {
    setStartFlag(true);
  }
 

  return (
    <>
      {modal && (
        // <Modal isOpen={modal} size="sm">
        //   <Modal.Body>
        //     <div>Do you want to go to next Question?</div>
        //   </Modal.Body>
        //   <Modal.Footer>
        //     <Button
        //       color="secondary"
        //       className="modalCloseBtn"
        //       onClick={toggleYes}
        //     >
        //       Yes
        //     </Button>
        //     <Button
        //       color="secondary"
        //       className="modalCloseBtn"
        //       onClick={toggle}
        //     >
        //       No
        //     </Button>
        //   </Modal.Footer>
        // </Modal>
      <Modal show={modal} size="md" centered contentClassName="mock-container">
      <Modal.Header style={{ padding: "0px" }} className="mock-popup-header">
        <div className="d-flex justify-content-end align-items-center p-2">
        <button onClick={toggle} className="modal-close-btn" >
          ×
        </button>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex gap-2 align-items-center mock-resource-text">
        <div className="d-flex justify-content-center align-items-center">
          <img
          src={InfoImage}
          alt="Information"
          style={{
            height: "40px",
            width: "30px",
            objectFit: "contain",
            display: "block",
          }}
          />
        </div>{" "}Do you want to go to next Question?
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
        color="secondary"
        className="mock-test-modal-button"
        onClick={toggleYes}
        >
        Yes
        </Button>
        <Button
        color="secondary"
        className="mock-test-modal-button"
        onClick={toggle}
        >
        No
        </Button>
      </Modal.Footer>
      </Modal>        
      )}
      <div
        className="content questionsArea deviceTestPage old-design m-0 p-0"
        // id="deviceTestPage"
        id="test-card"
      >
        <Row className="test_width">
          <Col xs={12} className="p-0">
            <div className="border-top-0 bg-transparent">
              <div className="p-0">
                <div
                  className="d-flex align-items-end flex-column gap-1 rounded-2 mock-header-gap"
                  // style={{ backgroundColor: "white" }}
                >
                  <div
                    className="d-flex justify-content-between align-items-center w-100 mock-header-bg"
                    style={{
                      // backgroundColor: "#BFBABB",
                      height: "40px",
                    }}
                  >
                    <div style={{ width: "fit-content", padding: "20px" }}>
                      <h4 className="m-0">Extensive Mock Test</h4>
                    </div>
                  </div>

                  <div
                    className="d-flex justify-content-end align-items-center px-4 w-100"
                    style={{
                      backgroundColor: "#0081A4",
                      minHeight: "40px",
                    }}
                  >
                    <div className="d-flex justify-content-end gap-3">
                      <img
                        src={isFullScreen() ? ExitFullScreen : FullScreen}
                        onClick={() => {
                        toggleFullScreen();
                        setTimeout(() => {
                          forceUpdate({});
                        }, 100);
                        }}
                        alt={isFullScreen() ? "Exit Full Screen" : "Full Screen"}
                        className="toggle-icons"
                      />
                      <img
                        src={isDarkMode() ? LightMode : DarkMode}
                        onClick={() => {
                        toggleTheme();
                        forceUpdate({});
                        }}
                        alt={isDarkMode() ? "Light Mode" : "Dark Mode"}
                        className="toggle-icons"
                      />		
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} className="p-0 test_width">
            <Card className="border-0 mock-container" id="extensive-mock-test">
              <Card.Body>
                {headphone && (
                  <div className="col-xs-12 successContent justify-content-start mock-resource-text">
                    <div className="row">
                      <div className="col-sm-8">
                        <h4 className="mt-0">Headset check</h4>
                        <h6>
                          This is an opportunity to check that your headset is
                          working correctly
                        </h6>
                        <ol>
                          <li>
                            Put your headset on and adjust it so that if it's
                            comfortably over your ears
                          </li>
                          <li>
                            When you are ready. cilck on the play button. You
                            hear a short recording
                          </li>
                          <li>
                            If you do not hear anything in your headphones while
                            the status reads Playing. Raise your hard to get the
                            alteration of the Test Administator
                          </li>
                        </ol>
                        <div className="currentStatus d-flex justify-content-center align-items-center p-0  audio-player-section">
                          <div className="w-100 text-white p-4">
                            <div className="d-flex justify-content-center align-items-center w-100 gap-2">
                              {soundStatus ? (
                                <button
                                  className="bg-transparent text-white border-0"
                                  onClick={offSound}
                                >
                                  <i
                                    className="fa fa-stop"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                              ) : (
                                <button
                                  className="bg-transparent text-white border-0"
                                  onClick={onSound}
                                >
                                  <i
                                    className="fa fa-play"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                              )}
                              <div className="flex-grow-1 mt-4">
                                {/* <Progress
                                  style={{
                                    backgroundColor: "#e9ecef",
                                    height: "15px",
                                  }}
                                  barStyle={{ backgroundColor: "#4493e0" }}
                                  value={soundPer}
                                /> */}
                                <ProgressBar
                                  now={soundPer}
                                  style={{ backgroundColor: "#e9ecef", height: "15px" }}
                                  variant="primary"
                                />
                                <p style={{ fontSize: "11px" }}>
                                  Click the play button to start
                                </p>
                              </div>
                            </div>
                            <br></br>
                            <div className="w-100 d-flex justify-content-center align-items-center">
                              <div className="d-flex justify-content-center gap-3  align-items-center w-50">
                                <i
                                  className="fa fa-volume-up"
                                  aria-hidden="true"
                                ></i>
                                <Form.Range
                                  min={0}
                                  max={100}
                                  step={1}
                                  defaultValue={volume}
                                  onChange={changeRange}
                                  aria-label="Volume"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="testingImgOuter">
                          <img
                            src={HeadsetCheck}
                            alt="headset"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="note w-100">
                      <ul>
                        <li className="list-unstyled">
                          During the test you will not have Play and Stop
                          buttons. The audio recording will start playing
                          automatically
                        </li>
                        <li className="list-unstyled">
                          Please do not remove your headset. You should wear it
                          throughtout the test
                        </li>
                      </ul>
                    </div>
                  </div>
                )}

                {speak_inst && (
                  <div className="col-xs-12 successContent justify-content-start mock-resource-text">
                    <div className="row w-100">
                      <div className="col-lg-12">
                        <h4 className="mt-0">Speaking Instructions</h4>
                        <h6>
                          Some questions require you to first listen to an audio
                          clip and then record your answer by speaking clearly
                          into the microphone.
                        </h6>
                        <div className="row speakingStatus mb-5 mt-4">
                          <div className="col-sm-4">
                            <p>
                              <b>Listening: </b>The Current Status shows how
                              long you have until the audio clip starts.
                            </p>
                            <img src={currentStatus} />
                          </div>
                          <div className="col-sm-6 pl-5">
                            <p>
                              A blue bar shows the progress of the audio clip.
                              When it reaches the right hand side the audio,
                              clip will stop playing.
                            </p>
                            <div className="row doubleImges">
                              <div className="col-sm-6">
                                <img src={completeStatus} />
                              </div>
                              <div className="col-sm-6">
                                <img src={playingStatus} />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row speakingStatus">
                          <div className="col-sm-4">
                            <p>
                              <b>Speaking: </b>The Current Status shows how long
                              you have until the microphone opens. Start
                              speaking when the status changes to recording.
                            </p>
                            <img src={currentStatus} />
                          </div>
                          <div className="col-sm-6 pl-5">
                            <p>
                              You must finish before the progress bar reaches
                              the right hand side. If you remain silent for
                              longer than 3 seconds, the recording will stop.
                              You will not be able to re-record.
                            </p>
                            <div className="row doubleImges">
                              <div className="col-sm-6">
                                <img src={completeRecord} />
                              </div>
                              <div className="col-sm-6">
                                <img src={currentRecording} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {test_intro && (
                  <div className="col-xs-12 successContent justify-content-start mock-resource-text">
                    <div className="row w-100">
                      <div className="col-lg-12">
                        <h4 className="mt-0">Test Introduction</h4>
                        <h6>
                            This test measures the Reading, Writing, Listening
                            and Speaking skills in English that you will need in
                            an academic setting.
                        </h6>
                        <ol>
                          <li>
                            The test is divided into 3 parts. Each part may
                            contain a number of sections. The sections are
                            individually timed. The timer will be shown in the
                              top right corner of your screen. The number of
                              items in the section will also be displayed.
                            <div className="timeBlock">
                              <div className="timeBlockInr text-right">
                                <p>
                                  <i
                                    className="fa fa-clock-o"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  Time Remaining : 00:32:56
                                </p>
                                <p>Item 22 of 39</p>
                              </div>
                            </div>
                          </li>
                          <li>
                            At the beginning of each part you will receive
                              instructions. These will provide details on what
                              to expect in that part of the test.
                          </li>
                          <li>
                              By clicking on the Next (N) button at the bottom
                              of each screen you confirm your answer and move to
                              the next question. If you click on Next (N) you
                              will not be able to return to the previous
                              question. You will not be able to revisit any
                              question at the end of the test.
                          </li>
                          {props.data.break === 0 ? (
                            <li>
                              You will be offered a break of up to 10 minutes
                              before Listening part. The break is optional.
                            </li>
                          ) : (
                            ""
                          )}
                          <li>
                            This test makes use of different varieties of
                              English, for example, British, American,
                              Australian. You can answer in the standard English
                              variety of your choice.
                          </li>
                          <li>
                              During the test, do not click on any browser
                              buttons (front, back, or reload). If you want to
                              leave in between any sections, just use Save &
                              Exit button. And if you want to leave after
                              finshing a section, just use Save and Exit button.
                          </li>
                        </ol>
                      </div>
                    </div>
                  </div>
                )}
                {mic && (
                  <div className="col-xs-12 successContent justify-content-start mock-resource-text">
                    <div className="row w-100">
                      <div className="col-sm-8">
                        <h4 className="mt-0">Microphone Check</h4>
                        <h6>
                          This is an opportunity to check that your microphone
                          is working correctly
                        </h6>
                        <h6>Speaking works best with a proper headset and quiet environment.</h6>
                        <ol>
                          <li>
                            Make sure your headset is on and the microphone is
                            in the downward position near your mouth.
                          </li>
                          <li>
                            When you are ready, click on the Record button and
                            say "Testing, testing, one, two, three" into the
                            microphone
                          </li>
                          <li>
                            After you have spoken, cilck on the Stop button.
                            Your recording is now complete
                          </li>
                          <li>
                              Now click on the Playback button. You should
                              clearly hear yourself speaking
                          </li>
                          <li>
                              If you can not hear your voice clearly. please
                              raise your hand to get the atteration of the Test
                            Administrator
                          </li>
                        </ol>
                        {/* <div className="currentStatus d-none">
                          <p>Status: Click record to begin</p>
                          <ProgressBar
                            now={recordPer}
                            style={{ backgroundColor: "#e9ecef", height: "15px" }}
                            variant="primary"
                          />
                          <div className="stop-btn">
                            <Button
                              color="success"
                              disabled={isRecording}
                              className="p-5px"
                              onClick={startRecording}
                              size="xs"
                            >
                              Record
                            </Button>
                            <Button
                              color="success"
                              onClick={playRecording}
                              className="p-5px"
                              size="xs"
                            >
                              {btnText}
                            </Button>
                            <Button
                              color="success"
                              disabled={!isRecording}
                              onClick={stopRecording}
                              className="p-5px"
                              size="xs"
                            >
                              Stop
                            </Button>
                          </div>
                          {isRecording && (
                            <div>
                              Recording is started, please click on stop button
                              for stop recording
                            </div>
                          )}
                        </div> */}
                        <div
                          className="d-block d-lg-flex flex-column flex-md-row justify-content-start align-items-center gap-3"
                          style={{ minHeight: "60px" }}
                        >
                          <div className="d-flex">
                            {!isRecording && blobURL && (
                              <Button
                                color="success"
                                onClick={playRecording}
                                className="custom-btn-design mock-bottom-btn border-0"
                                size="xs"
                              >
                                {btnText}
                              </Button>
                            )}
                            {isRecording ? (
                              <Button
                                color="success"
                                onClick={stopRecording}
                                className="custom-btn-design mock-bottom-btn border-0"
                                size="xs"
                              >
                                Stop
                              </Button>
                            ) : (
                              <Button
                                color="success"
                                className="custom-btn-design mock-bottom-btn border-0"
                                onClick={startRecording}
                                size="xs"
                              >
                                Record
                              </Button>
                            )}
                          </div>
                          <div className="d-flex gap-2 w-100 w-md-50" >
                            {isRecording ? (
                              <img
                                src={stopImage}
                                alt="Stop Recording"
                                style={{
                                  height: "65px",
                                  width: "65px",
                                  objectFit: "contain",
                                  display: "block",
                                }}
                              />
                            ) : (
                              <div className="d-flex justify-content-center align-items-center">
                                <img
                                  src={grayImage}
                                  alt="Not Recording"
                                  style={{
                                    height: "65px",
                                    width: "65px",
                                    objectFit: "contain",
                                    display: "block",
                                  }}
                                />
                                <p
                                  className="text-center p-0 m-0"
                                  style={{ fontSize: "20px" }}
                                >
                                  Ready
                                </p>
                              </div>
                            )}
                            <div
                              className="d-flex align-items-center flex-grow-1 mb-4"
                              style={{ height: "40px" }}
                            >
                              <div style={{ maxWidth: "300px", width: "100%" }}>
                                <MicWaveform
                                  key={waveformKey}
                                  progressValue={recordPer}
                                  mockColor="#0081A4"
                                />
                              </div>
                            </div>
                          </div>

                        </div>
                        <div className="note">
                          <ul>
                            <li>
                              During the test, you will not have Record,
                              Playback, and Stop buttons. The voice recording
                              will start automatically.
                            </li>
                          </ul>
                        </div>
                        <ReusableRecorder
                          ref={recorderRef}
                          onRecordingComplete={handleRecordingComplete}
                          onRecordingStart={handleRecordingStart}
                          onRecordingStop={handleRecordingStop}
                          maxDuration={40000}
                          enableSpeechRecognition={false}
                          fileName="mic-test.mp3"
                        />
                      </div>
                      <div className="col-sm-4">
                        <div className="testingImgOuter">
                          <img
                            src={HeadsetCheck}
                            alt="headset"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {keyboard && (
                  <div className="col-xs-12 successContent justify-content-start mock-resource-text">
                    <div className="col-lg-12">
                      <h4 className="mt-0">Keyboard Check</h4>
                      <h6>
                        This is an opportunity to check that you have the
                        correct keyboard.
                      </h6>
                      <div className="col-xs-12">
                        <ol>
                          <li>
                            Look at the top row of letters on the keyboard.
                          </li>
                          <li>
                            The letters should appear in this order Q W E R T Y.
                          </li>
                          <li>
                            If you do not have a QWERTY keyboard, raise your
                            hand to get the attention of the Test Administrator
                          </li>
                        </ol>
                        <div className="keyboardImg">
                          <img src={img} alt="keyboard" />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {testDetail && (
                  <div className="col-xs-12 successContent justify-content-start mock-resource-text">
                    <div className="col-lg-12">
                      <h4 className="mt-0">
                        Welcome {store.getState().user.first_name}{" "}
                        {store.getState().user.last_name === 'null' ? '' : store.getState().user.last_name}
                      </h4>
                      <div className="col-xs-12">
                        <table className="table table-bordered">
                          <tbody>
                            <tr>
                              <th>Part</th>
                              <th>Content</th>
                              <th>Time Allowed</th>
                            </tr>
                            <tr>
                              <td>1</td>
                              <td>Speaking & writing</td>
                              <td>{props.data.time[0]} minutes</td>
                            </tr>
                            <tr>
                              <td>2</td>
                              <td>Reading</td>
                              <td>{props.data.time[1]} minutes</td>
                            </tr>
                            {props.data.break === 0 ? (
                              <tr>
                                <td colSpan={2}>Optional scheduled break</td>
                                <td>10 minutes</td>
                              </tr>
                            ) : (
                              ""
                            )}
                            <tr>
                              <td>3</td>
                              <td>Listening</td>
                              <td>{props.data.time[2]} minutes</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
                {intro && <IntroTest props = {props}/>}
                {currDetail && (
                  <div className="col-xs-12 successContent justify-content-start mock-resource-text">
                    <div className="col-lg-12">
                      <h4 className="mt-0">
                        Welcome {store.getState().user.first_name}{" "}
                        {store.getState().user.last_name === 'null' ? '' : store.getState().user.last_name}
                      </h4>
                      <div className="col-xs-12">
                        <table className="table table-bordered">
                          <tbody>
                            <tr>
                              <th>Section</th>
                              <th>No of Question</th>
                              <th>Time Allowed</th>
                            </tr>
                            <tr>
                              <td>Speaking & writing</td>
                              <td>{props.data.full[0].length}</td>
                              <td>{props.data.time[0]} minutes</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
                {soundStatus && (
                  <Sound
                    url={s3base + "/ptedata/ptemedia/AUD (2)_1539694341.mp3"}
                    playStatus={Sound.status.PLAYING}
                    onFinishedPlaying={handleSongFinishedPlaying}
                    onPlaying={handleSongPlaying}
                    volume={volume}
                    onError={(err) => {
                      if (err.name !== "AbortError") console.error(err);
                    }}
                  />
                )}
                {blobURL && recordingSoundStatus && (
                  <Sound
                    url={blobURL}
                    playStatus={Sound.status.PLAYING}
                    onPlaying={handleRecordPlaying}
                    onFinishedPlaying={recordingFinishedPlaying}
                  />
                )}
                <ReusableRecorder
                  ref={recorderRef}
                  onRecordingComplete={handleRecordingComplete}
                  onRecordingStart={handleRecordingStart}
                  onRecordingStop={handleRecordingStop}
                  maxDuration={40000}
                  enableSpeechRecognition={false}
                  fileName="mic-test.mp3"
                />
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12}>
            {/* <div className="bottomBtns d-none">
              <Row>
                <Col xs={9}></Col>

                <Col xs={3}>
                  {!startFlag && (
                    <Button
                      color="primary"
                      disabled={!nextFlag}
                      onClick={nextButton}
                      size="xs"
                    >
                      NEXT
                    </Button>
                  )}
                  {startFlag && (
                    <Button color="primary" onClick={props.showTest} size="xs">
                      Next
                    </Button>
                  )}
                </Col>
              </Row>
            </div> */}
            <div className="bottom-0 bottomBtns d-flex justify-content-center m-0 p-0 position-fixed w-101 mock-header-gap">
              <Row className="align-items-center mx-0 gap-1 fixed-bottom-row w-100 mock-header-gap">
                <Col
                  className="text-center py-2 z-3 mock-bottom-btn-toggle flex-grow-1" style={{ minHeight: "50px" }}
                ></Col>

                <Col
                  xs="auto" className="d-flex justify-content-center align-items-center py-1 mock-bottom-btn-toggle" style={{ minWidth: "15%",minHeight: "50px" }}
                >
                  {!startFlag && (
                    <Button
                      color="primary"
                      disabled={!nextFlag}
                      onClick={nextButton}
                      size="xs"
                      className="mock-btn bottomBtnFont mock-bottom-btn"
                    >
                      NEXT
                    </Button>
                  )}
                  {startFlag && (
                    <Button
                      color="primary"
                      onClick={props.showTest}
                      size="xs"
                      className="mock-btn bottomBtnFont mock-bottom-btn"
                      disabled={mic && !isCompleted}
                    >
                      Next
                    </Button>
                  )}
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ResourceCheck;